import {newsletterCheckForResultSection} from '../globals/newsletter';
import {register} from '../vendor/theme-scripts/theme-sections';

register('newsletter', newsletterCheckForResultSection);
